import React from 'react';

function Roadmap() {
  return (
    <div className="page roadmapping" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>Roadmap</h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        This page outlines planned improvements and ideas for the Movie Identifier web app.
      </p>

      <section style={{ marginBottom: '2rem' }}>
        <h2>In progress</h2>
        <ul>
          <li>Stability and performance improvements for video processing</li>
          <li>Better error messages and edge-case handling</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2>Next up</h2>
        <ul>
          <li>History export and manual notes for found movies</li>
          <li>Shareable result links</li>
          <li>Dark mode refinements</li>
          <li>Mobile UX tweaks</li>
        </ul>
      </section>

      <section>
        <h2>Completed recently</h2>
        <ul>
          <li>Link-based search (Shorts/Reels) — experimental</li>
          <li>Details panel with basic metadata (director, actors, year, etc.)</li>
          <li>Recent searches section</li>
        </ul>
      </section>

      <p style={{ marginTop: '2rem' }}>
        Have suggestions? Send feedback to <a href="mailto:letmeplzdoit@gmail.com">letmeplzdoit@gmail.com</a>.
      </p>
    </div>
  );
}

export default Roadmap;




